module.exports = __webpack_public_path__ + "img/base.154e2ba1.svg";